import Vue from 'vue'
import Router from 'vue-router'

import customerCase from '@/pages/customer-case'
import Home from '@/pages/home';
import OpenPlatform from '@/pages/open-platform'
import Solution from '@/pages/solution';
import ContactUs from '@/pages/contact-us';



Vue.use(Router)


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '智能门禁_智能会议室_智能办公-首页'
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        title: '智能门禁_智能会议室_智能办公-首页'
      }
    },
    {
      path: '/customer_case',
      name: 'customer_case',
      component: customerCase,
      meta: {
        title: '智能门禁_智能会议室_智能办公-客户案例'
      }
    },
    {
      path: '/solution',
      name: 'Solution',
      component: Solution,
      meta: {
        title: '智能门禁_智能会议室_智能办公-解决方案'
      }
    },
    {
      path: '/contactus',
      name: 'ContactUs',
      component: ContactUs,
      meta: {
        title: '智能门禁_智能会议室_智能办公-联系我们'
      }
    },
    {
      path: '/open_platform',
      name: 'OpenPlatform',
      component: OpenPlatform,
      meta: {
        title: '智能门禁_智能会议室_智能办公-开放平台'
      }
    },


  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})




// WEBPACK FOOTER //
// ./src/router/index.js